import React from "react";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import FlightIcon from "@mui/icons-material/Flight";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";

const steps = [
  {
    title: "Sign Up",
    subtitle: "Fill in your details below",
    icon: "/gettingStarted1.svg",
  },
  {
    title: "Activate",
    subtitle: "Access your dashboard instantly",
    icon: "/gettingStarted2.svg",
  },
  {
    title: "Sell Travel",
    subtitle: "Start booking flights, hotels, tours & insurance",
    icon: "/gettingStarted3.svg",
  },
  {
    title: "Scale",
    subtitle: "Upgrade with a website or API as you grow",
    icon: "/gettingStarted4.svg",
  },
];

const curveSrc = "/curve-placeholder.svg";

export default function HomeGettingStartedSection() {
  return (
    <section className="w-full px-6 py-10 bg-white">
      <h3 className="text-2xl font-bold text-center mb-6">
        Getting Started is Simple
      </h3>

      <div className="bg-gray-100 rounded-xl p-4 shadow-sm border border-gray-100">
        <div className="flex flex-col gap-x-4">
          <div className="flex flex-col">
            {steps.map((s, i) => (
              <div className="w-full flex flex-col group " key={s.title}>
                <div className="flex gap-3 w-full items-center">
                  <div className="w-12 h-12 rounded-lg bg-[#A2DDFF] flex items-center justify-center">
                    <img src={s.icon} alt="" className="w-6 object-contain" />
                  </div>
                  <div className="py-2 flex flex-1 flex-col">
                    <div className="text-base font-semibold text-black">
                      {s.title}
                    </div>
                    <div className="text-sm text-gray-500 leading-relaxed">
                      {s.subtitle}
                    </div>
                  </div>
                </div>
                {steps.length - 1 !== i && (
                  <div
                    className={`flex  group-last:hidden w-12 h-12 ${
                      i === 0
                        ? "-my-4"
                        : i === 1
                        ? "-mt-4 -mb-6"
                        : i === 2
                        ? "-my-7"
                        : ""
                    }  ${i % 2 === 0 ? " justify-end" : " justify-start"}`}
                  >
                    <img
                      src={i % 2 === 0 ? "/curveRight.png" : "/curveLeft.png"}
                      alt=""
                      className={"h-12 object-contain"}
                    />
                  </div>
                )}
              </div>
            ))}

            <button className="mt-5 w-full rounded-xl py-3 text-white font-semibold bg-primary1 shadow-sm active:scale-[.99]">
              Sign Up Now!
            </button>
          </div>
        </div>
      </div>

      <div className="mt-4 rounded-2xl bg-blue-50 text-primary1 px-4 py-3 text-sm">
        <span className="mr-1">🎁</span>
        Expo Special: Get 1 month free subscription + instant booth rewards when
        you register today.
      </div>
    </section>
  );
}
